export default {"src":"/_next/static/media/idea.mono.1de3aa97.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};